class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()).then((parsedState) => {
        if(window.freeShippingConfig.enable && window.freeShippingConfig.enablegift == 0){window.initFreeshippingGoal(parsedState)};
        if(window.freeShippingConfig.enable == 0 && window.freeShippingConfig.enablegift || window.freeShippingConfig.enable && window.freeShippingConfig.enablegift){window.initFreegiftGoal(parsedState)};
    }).catch((e) => {
        console.error(e);
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector,sectionElement);
    });

    if(document.querySelectorAll('.upcell-drawer .upcell-item').length > 0){
      setTimeout(() => {
        const swiperObj = new Swiper(document.querySelector('.upcell-drawer'), {
          "slidesPerView": 1,
          "navigation": {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          "on": {
            "init": function () {
              let maxHeight = 0;
              var get_all_slide = document.querySelectorAll('.upcell-main-wrap .upcell-data-wrap .upcell-item');
              get_all_slide.forEach(div => {
                  if (div.querySelector('.upcell-item-title').offsetHeight > maxHeight) {
                      maxHeight = div.querySelector('.upcell-item-title').offsetHeight;
                  }
              });
              
              get_all_slide.forEach(div => {
                  div.querySelector('.upcell-item-title').style.height = `${maxHeight}px`;
              });
            }
          }
        });
      }, 1000);
    }

    if(window.freeShippingConfig.enable && window.freeShippingConfig.enablegift == 0){window.initFreeshippingGoal(parsedState)};
    if(window.freeShippingConfig.enable == 0 && window.freeShippingConfig.enablegift || window.freeShippingConfig.enable && window.freeShippingConfig.enablegift){window.initFreegiftGoal(parsedState)};

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section',sectionElement=null) {
    console.log(sectionElement,'sectionElement');
    var curr_html = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if(curr_html.querySelector('.drawer__inner>.free-shipping-goal-section') && sectionElement != null && sectionElement.querySelector('.drawer__inner>.free-shipping-goal-section') != null){
      curr_html.querySelector('.drawer__inner>.free-shipping-goal-section').innerHTML = sectionElement.querySelector('.drawer__inner>.free-shipping-goal-section').innerHTML;
    }
    return curr_html.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__header',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__footer',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: 'cart-drawer-items',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
